import React from 'react';

const TabsWrapperContext = React.createContext({
  index: null,
  data: [],
  onChangeIndex: () => {},
});

export default TabsWrapperContext;
